import React, { Component } from "react";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";

import guidelinesData from "./Guidelines.data.json";

import Type from "../../Global/Typography.js";
import NanoFlex from "./../../Global/NanoFlex.js";
import Input from "./../../Nano/Input.js";
import Button from "../../Nano/Buttons/Button.js";
import Modal from "../../Global/Modal.js";
import WarningContent from "../../Micro/Warning/WarningContent.js";
import SocialIcons from "../../Nano/SocialIcons.js";
import Loading from "./../../Nano/Loading.js";
import Spinner from "./../../Nano/Spinner.js";
import Grid from "./../../Macro/Grid.js";
import WrapperList from "./../../Nano/WrapperList.js";
import ViewMore from "./../../Nano/ViewMore.js";
import TitleCard from "./../../Nano/TitleCard.js";
import Dropdown from "../../Nano/Dropdown.js";
import DateRangePicker from "../../Nano/DateRangePicker.js";
import InputWheel from "../../Nano/InputWheel.js";
import DateInputWheel from "../../Nano/DateInputWheel.js";
import Calendar from "../../Micro/Calendar.js";
import MultipleSelectionDropdown from "../../Nano/MultipleSelectionDropdown.js";
import TimeInputWheel from "../../Nano/TimeInputWheel.js";
import Checkbox from "../../Nano/Checkbox.js";
import TreeNavigator from "../../Nano/TreeNavigator.js";
import TreeNavigatorDropdown from "../../Nano/TreeNavigatorDropdown.js";
import RadioButtons from "../../Nano/RadioButtons.js";
import Timeline from "../../Nano/Timeline.js";
import WeekSelect from "../../Nano/WeekSelect.js";
import PlatformSelect from "../../Nano/PlatformSelect.js";
import AudienceBoosterSelect from "../../Nano/AudienceBoosterSelect.js";
import AddToPlaylistModal from "../../Micro/AddToPlaylistModal.js";
import RemoveFromPlaylistModal from "../../Micro/RemoveFromPlaylistModal.js";
import PlaylistModal from "../../Micro/PlaylistModal.js";
import CreatePlaylistModal from "../../Micro/CreatePlaylistModal.js";
import SaveSearchModal from "../../Micro/SaveSearchModal.js";
import NotaSelectionSelect from "../../Nano/NotaSelectionSelect.js";
import InputDate from "../../Nano/InputDate.js";
import RecapFiltersModal from "../../Micro/RecapFiltersModal.js";
import SharePlaylistModal from "../../Micro/SharePlaylistModal.js";
import PasswordManagementModal from "../../Micro/PasswordManagementModal.js";
import BiggerThumbHover from "../../Micro/BiggerThumbHover.js";
import CookiesModal from "../../Micro/CookiesModal.js";

import { ReactComponent as Logo } from "../../../images/nota.svg";

const StyledGuidelines = styled.div`
  .logo {
    path {
      fill: ${nota.color.main.default};
    }
  }
`;

export class Guidelines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      openAddToPlaylistModal: false,
      openRemoveFromPlaylistModal: false,
      openSaveSearchModal: false,
      openPlaylistModal: false,
      openCreatPlaylistModal: false,
      openSharePlaylistModal: false,
      openPasswordManagementModal: false,
      openCookiesModal: false,
      showPassword: false,
      loading: false,
      toggleCheckbox: false,
    };
  }

  render() {
    return (
      <StyledGuidelines>
        <NanoFlex flexDirection="column" height="auto">
          {/* Logo && Title */}
          <NanoFlex className="logo" flexDirection="column" margin="80px">
            <Logo />
            <Type.h1>
              <b>Guidelines</b>
            </Type.h1>
          </NanoFlex>

          {/* Typography */}
          <NanoFlex flexDirection="column">
            <Type.h1>
              H1 Test <b>Test Bold</b>
            </Type.h1>
            <Type.h1 white>
              H1 White Test <b>Test Bold</b>
            </Type.h1>

            <Type.h2>
              H2 Test <b>Test Bold</b>
            </Type.h2>
            <Type.h3>
              H3 Test <b>Test Bold</b>
            </Type.h3>
            <Type.h4>
              H4 Test <b>Test Bold</b>
            </Type.h4>

            <Type.h5>
              H5 Test <b>Test Bold</b>
            </Type.h5>

            <Type.h6>
              H6 Test <b>Test Bold</b> <i>Test Italic</i>{" "}
              <i>
                <b>Test Italic Bold</b>
              </i>
            </Type.h6>
            <Type.h6 white>
              H6 White Test <b>Test Bold</b> <i>Test Italic</i>{" "}
              <i>
                <b>Test Italic Bold</b>
              </i>
            </Type.h6>

            <Type.p>
              P Test <b>Test Bold</b> <i>Test Italic</i>{" "}
              <i>
                <b>Test Italic Bold</b>
              </i>{" "}
              <em>Test EM</em>
            </Type.p>
            <Type.p white>
              P White Test <b>Test Bold</b> <i>Test Italic</i>{" "}
              <i>
                <b>Test Italic Bold</b>
              </i>{" "}
              <em>Test EM</em>
            </Type.p>
          </NanoFlex>

          {/* Button */}
          <NanoFlex flexDirection="column">
            <Button id={1} label={"login"} clickAction={(id) => console.log(id)} />
            <Button id={2} label={"login"} disable />

            <Button label={"continue"} warning />

            <Button id={3} label={"free trial"} secondary />
            <Button id={4} label={"free trial"} secondary disable />

            <Button label={"CANCEL"} simple />
            <Button label={"CANCEL"} simple disable />
          </NanoFlex>

          {/* Spinner */}
          <Spinner />

          {/* Loading */}
          <Loading />

          {/* Loading */}
          <Button id={1000} label={"Open Loading"} clickAction={() => this.setState({ loading: true })} />
          {this.state.loading && (
            <NanoFlex onClick={() => this.setState({ loading: false })}>
              <Loading />
            </NanoFlex>
          )}

          {/* Modal */}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"Open Modal"} clickAction={() => this.setState({ openModal: true })} />
            <Modal show={this.state.openModal} content={<WarningContent cancelAction={() => this.setState({ openModal: false })} nextAction={() => this.setState({ openModal: false })} />} />
          </NanoFlex>

          {/* Playlists Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"Playlists"} clickAction={() => this.setState({ openPlaylistModal: true })} />
            <Modal show={this.state.openPlaylistModal} content={<PlaylistModal cancelAction={() => this.setState({ openPlaylistModal: false })} nextAction={() => this.setState({ openPlaylistModal: false })} />} />
          </NanoFlex>

          {/* Add To Playlist Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"Add To Playlist"} clickAction={() => this.setState({ openRemoveFromPlaylistModal: true })} />
            <Modal show={this.state.openRemoveFromPlaylistModal} content={<AddToPlaylistModal cancelAction={() => this.setState({ openRemoveFromPlaylistModal: false })} nextAction={() => this.setState({ openRemoveFromPlaylistModal: false })} />} />
          </NanoFlex>

          {/* Remove from Playlist Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"Remove From Playlist"} clickAction={() => this.setState({ openAddToPlaylistModal: true })} />
            <Modal show={this.state.openAddToPlaylistModal} content={<RemoveFromPlaylistModal cancelAction={() => this.setState({ openAddToPlaylistModal: false })} nextAction={() => this.setState({ openAddToPlaylistModal: false })} />} />
          </NanoFlex>

          {/* CREAT PLAYLIST Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"CREATE Playlists"} clickAction={() => this.setState({ openCreatPlaylistModal: true })} />
            <Modal show={this.state.openCreatPlaylistModal} content={<CreatePlaylistModal cancelAction={() => this.setState({ CreatPlaylistModal: false })} nextAction={() => this.setState({ CreatPlaylistModal: false })} />} />
          </NanoFlex>

          {/* SAVE & SEARCH  Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"SAVE & SEARCH"} clickAction={() => this.setState({ openSaveSearchModal: true })} />
            <Modal show={this.state.openSaveSearchModal} content={<SaveSearchModal cancelAction={() => this.setState({ openPlaylistModal: false })} nextAction={() => this.setState({ openPlaylistModal: false })} />} />
          </NanoFlex>

          {/* SHARE PLAYLIST  Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"SHARE PLAYLIST"} clickAction={() => this.setState({ openSharePlaylistModal: true })} />
            <Modal show={this.state.openSharePlaylistModal} content={<SharePlaylistModal cancelAction={() => this.setState({ openSharePlaylistModal: false })} nextAction={() => this.setState({ openSharePlaylistModal: false })} />} />
          </NanoFlex>

          {/* PASSWORD MANAGEMENT  Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"PASSWORD MANAGEMENT "} clickAction={() => this.setState({ openPasswordManagementModal: true })} />
            <Modal show={this.state.openPasswordManagementModal} content={<PasswordManagementModal cancelAction={() => this.setState({ openPasswordManagementModal: false })} nextAction={() => this.setState({ openPasswordManagementModal: false })} />} />
          </NanoFlex>

          {/* RECAP  Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"RECAP FILTERS MODAL"} clickAction={() => this.setState({ openRecapFiltersModal: true })} />
            {/* <Modal show={this.state.openRecapFiltersModal} content={<RecapFiltersModal cancelAction={() => this.setState({ openRecapFiltersModal: false })} nextAction={() => this.setState({ openRecapFiltersModal: false })} />} /> */}
          </NanoFlex>

          {/* COOKIES  Modal*/}
          <NanoFlex flexDirection="column">
            <Button id={100} label={"COOKIES MODAL"} clickAction={() => this.setState({ openCookiesModal: true })} />
            <Modal show={this.state.openCookiesModal} content={<CookiesModal cancelAction={() => this.setState({ openCookiesModal: false })} nextAction={() => this.setState({ openCookiesModal: false })} />} />
          </NanoFlex>

          {/* BIGGET THUMB HOVER*/}
          <NanoFlex margin={"40px"}>
            <BiggerThumbHover />
          </NanoFlex>

          {/* Checkbox */}
          <Checkbox id={0} toggle={this.state.toggleCheckbox} label={"Checkbox Test"} onChangeAction={(id) => this.setState({ toggleCheckbox: !this.state.toggleCheckbox })} />

          {/* Social Icons */}
          <SocialIcons />

          {/* Timeline */}
          <NanoFlex margin={"40px"} width={"300px"}>
            <Timeline />
          </NanoFlex>

          {/* WeekSelect */}
          <NanoFlex margin={"40px"} width={"232px"}>
            <WeekSelect />
          </NanoFlex>

          {/*  PlatformSelect */}
          <NanoFlex margin={"40px"} width={"232px"}>
            <PlatformSelect />
          </NanoFlex>

          {/*  AudienceBoosterSelect */}
          <NanoFlex margin={"40px"} width={"232px"}>
            <AudienceBoosterSelect />
          </NanoFlex>

          {/* NotaSelectionSelect */}
          <NanoFlex margin={"40px"} width={"232px"}>
            <NotaSelectionSelect />
          </NanoFlex>

          {/* Input */}
          <NanoFlex flexDirection="column">
            <Input id={0} title="Username" placeholder="Username" error={false} onChangeAction={(currentValue, id, title, type) => console.log("onChangeAction", currentValue, id, title, type)} />
            <Input
              id={1}
              type={this.state.showPassword ? "text" : "password"}
              title="Password"
              placeholder=""
              eye={true}
              showPassword={this.state.showPassword}
              error={false}
              onClickEyeToggle={() => this.setState({ showPassword: !this.state.showPassword })}
              onChangeAction={(currentValue, id, title, type) => console.log("onChangeAction", currentValue, id, title, type)}
            />

            <Input id={2} title="Error" placeholder="Error" error={true} onChangeAction={(currentValue, id, title, type) => console.log("onChangeAction", currentValue, id, title, type)} />
          </NanoFlex>

          {/* Input Wheel */}
          <InputWheel data={guidelinesData.months} type="months" onDateChange={(type, index) => console.log("InputWheel", type, index)} />
          <DateInputWheel onDateChange={(date) => console.log("DateInputWheel => date", date)} />

          {/* Time Input Wheel */}
          <TimeInputWheel selectedRange={guidelinesData.timeInputWheel} onChangeInput={(obj) => console.log("TimeInputWheel => onChangeInput", obj)} />

          {/* Calendar DESKTOP */}
          <NanoFlex margin={"40px"}>
            <InputDate />
          </NanoFlex>

          {/* Calendar MOBILE */}
          <Calendar
            inputDate={{
              startDate: "27-02-2020",
              endDate: "27-04-2020",
            }}
            onChangeSelection={(obj) => console.log(obj)}
          />

          {/* Date Range Picker && Dropdown */}
          <Dropdown
            onClickOutsideClose
            main={
              <NanoFlex>
                <Button label={"Date Range Picker"} />
              </NanoFlex>
            }
            content={
              <NanoFlex>
                <DateRangePicker />
              </NanoFlex>
            }
          />

          {/* Multiple Selection Dropdown */}
          <MultipleSelectionDropdown
            selected={guidelinesData.months.filter((v, i) => {
              return i < 3;
            })}
            options={guidelinesData.months.map((v) => {
              return { id: v, name: v };
            })}
            onChangeSelection={(id) => console.log(id)}
          />

          {/* Tree Navigator */}
          <NanoFlex margin={"40px"} maxWidth="300px">
            <NanoFlex flexDirection={"column"} justifyContent="flex-start" alignItems="flex-start">
              <TreeNavigator
                main={
                  <NanoFlex justifyContent="flex-start">
                    <Type.h5>
                      <b>Group Title</b>
                    </Type.h5>
                  </NanoFlex>
                }
                content={
                  <div>
                    <Type.h5>
                      <b>Item 1</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 2</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 3</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 4</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 5</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 6</b>
                    </Type.h5>
                  </div>
                }
              />

              <TreeNavigator
                main={
                  <NanoFlex justifyContent="flex-start">
                    <Type.h5>
                      <b>Group Title</b>
                    </Type.h5>
                  </NanoFlex>
                }
                content={
                  <div>
                    <Type.h5>
                      <b>Item 1</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 2</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 3</b>
                    </Type.h5>
                    <TreeNavigator
                      main={
                        <NanoFlex justifyContent="flex-start">
                          <Type.h5>
                            <b>Group Title Item 4</b>
                          </Type.h5>
                        </NanoFlex>
                      }
                      content={
                        <div>
                          <Type.h5>
                            <b>Item 1</b>
                          </Type.h5>
                          <Type.h5>
                            <b>Item 2</b>
                          </Type.h5>
                          <Type.h5>
                            <b>Item 3</b>
                          </Type.h5>
                          <Type.h5>
                            <b>Item 4</b>
                          </Type.h5>
                          <Type.h5>
                            <b>Item 5</b>
                          </Type.h5>
                          <Type.h5>
                            <b>Item 6</b>
                          </Type.h5>
                        </div>
                      }
                    />
                    <Type.h5>
                      <b>Item 5</b>
                    </Type.h5>
                    <Type.h5>
                      <b>Item 6</b>
                    </Type.h5>
                  </div>
                }
              />
            </NanoFlex>
          </NanoFlex>

          <TreeNavigatorDropdown onChangeSelection={(list) => console.log(list)} options={guidelinesData.treeNavigatorDropdown} />

          {/* Radio Buttons */}
          <RadioButtons selectedId={3} onChangeSelection={(id) => console.log(id)} />

          {/* Card Block && Main List Block */}
          <NanoFlex flexDirection="column" margin={"40px"} maxWidth="1024px">
            <NanoFlex>
              <WrapperList background>
                <ViewMore />
                <TitleCard title={"Audience Boosters"} secTitle={"Top performing programmes compared to the channel timeslot"} />
                <Grid data={guidelinesData.programs} row={1} />
              </WrapperList>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledGuidelines>
    );
  }
}
